module.exports = __webpack_public_path__ + "img/photo_2023-11-19 17.43.56.7c11c111.jpg";